<template>
  <section class="tags-article">
    <div class="tags-content">
      <ul>
        <li
          class="normal-tags"
          :class="''=== currentTag ? 'active' : ''"
        >
          <nuxt-link to="/">推荐</nuxt-link>
        </li>
        <li
          v-for="(item, index) in tags"
          :key="index"
          class="normal-tags"
          :class="item.value === currentTag ? 'active' : ''"
        >
          <nuxt-link :to="$i18n.path(`tag/${item.value}`)">{{ $t(item.name) }}</nuxt-link>
        </li>

        <li class="normal-tags member">
          <a
            href="javascript:;"
            class="font-member"
            :class="'会员专享' === currentTag ? 'active' : ''"
          >会员专享
            <i class="iconfont">&#xe660;</i>
          </a>
          <span class="member-tags-content">
            <span
              v-for="i in membertag"
              :key="i.equityId"
              :class="$route.query.type === i.equityId ? 'active':''"
              @click="getMemberArticleList(i.equityId)"
            >
              {{i.title}}
            </span>
          </span>
        </li>
      </ul>
    </div>
  </section>
</template>
<script>
export default {
  props: ["tags", "nomore", "membertag"],
  data() {
    return {
      currentTag: "",

    };
  },
  components: {},
  methods: {
    preventDefault(e) {
      // 阻止默认事件
      let event = e || window.event;
      event.preventDefault()
    },
    changeTag(i, e) {
      this.preventDefault(e);
      this.currentTag = i;
      this.$emit("getTagArticle", i);
    },
    getMore() {
      if (this.currentTag !== '会员专享') {
        this.$emit("getMoreArticle", this.currentTag);
      } else {
        this.$emit("getMoreResearchReport");
      }
    },
    getMemberArticleList(i) {
      this.$router.push({
        path: '/tag/会员专享',
        query: {
          type: i
        }
      })
    }
  },
  created() {
    this.currentTag = this.$route.params.type ? this.$route.params.type : ''
  },
  watch: {
    $route: {
      handler() {
        this.currentTag = this.$route.params.type ? this.$route.params.type : ''
      },
      deep: true
    }
  }
};
</script>
<style lang="less" scoped>
.tags-article {
  width: 852px;
  background: #fff;
  // padding: 0 20px 20px;
  // padding-bottom: 20px;
  margin-top: 20px;

  .tags-content {
    ul {
      width: 100%;
      padding-top: 5px;
      border-bottom: 1px solid #f1f3f7;
      box-sizing: border-box;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-around;
      align-items: center;

      li.normal-tags {
        // float: left;
        width: 1;
        height: 50px;
        text-align: center;
        cursor: pointer;
        padding: 6px;
        position: relative;
        &.active {
          // font-size: 1.3em;
          // line-height: 1.2em;
          font-weight: bolder;
          padding: 6px 5px;
          &::after {
            content: '';
            display: block;
            width: 40%;
            border: 2px solid #3278d2;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
          }
        }

        &:hover {
          a {
            font-weight: bold;
          }
          .member-tags-content {
            display: block;
          }
        }
        a {
          width: 100%;
          height: 40px;
          display: block;
          line-height: 40px;
          cursor: pointer;
          color: #000;
        }

        a.font-member {
          &.active {
            // font-size: 1.3em;
            // line-height: 1.2em;
            font-weight: bolder;
            &::after {
              content: '';
              display: block;
              width: 40%;
              border: 2px solid #3278d2;
              position: absolute;
              bottom: 0;
              left: 42%;
              transform: translateX(-50%);
            }
          }
          i {
            font-size: 12px;
            color: #999;
          }
        }

        .member-tags-content {
          background: #fff;
          width: 110px;
          position: absolute;
          top: 46px;
          left: -15px;
          z-index: 999;
          display: none;
          box-shadow: 0px 2px 8px 0px rgba(13, 27, 74, 0.12);

          &:before {
            content: '';
            border: 8px solid transparent;
            border-bottom-color: rgba(13, 27, 74, 0.12);
            position: absolute;
            left: 45px;
            top: 0;
            margin-top: -16px;
          }
          &:after {
            content: '';
            border: 8px solid transparent;
            border-bottom-color: white;
            position: absolute;
            top: 0;
            left: 45px;
            margin-top: -15px;
          }
          span {
            display: block;
            width: 100%;
            line-height: 36px;
            text-align: center;
            color: #666;
            height: 36px;
            font-size: 14px;
            cursor: pointer;
            &.active {
              font-weight: bolder;
              color: #333;
              background: #f6f6f6;
            }
            &:hover {
              color: #333;
              font-weight: 600;
              background: #f6f6f6;
            }
          }
        }
      }
    }
  }
}
</style>
